module.exports = __webpack_public_path__ + "img/Tessellate33.7c21fae9.jpg";